import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';  
import exampleReducer from './features/examples';
import userReducer from './auth';
import appReduser from './app';
import productReducer from './product';
import cartReducer from './cart';

// The bag survives a reload, but "is the drawer open" must not — rehydrating
// that would pop the bag open on every visit.
const cartPersistConfig = {
    key: 'cart',
    version: 1,
    storage,
    blacklist: ['open'],
  };

const rootReducer = combineReducers({
    example: exampleReducer,
    user: userReducer,
    app: appReduser,
    product: productReducer,
    cart: persistReducer(cartPersistConfig, cartReducer),
  });

const persistConfig = {
    key: 'root',
    version: 2,
    storage,
    // The cart runs its own persistor above (it has to drop `open`). Leaving it
    // out here keeps the root snapshot from restoring that flag behind its back.
    blacklist: ['cart'],
    // v2 reshaped the product slice (single product -> catalogue + selection).
    // Drop anything older rather than rehydrating an incompatible shape.
    migrate: (state: any) =>
      Promise.resolve(state?._persist?.version === 2 ? state : undefined),
  };
  
  const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
    devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;